import React from 'react';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Ves un diagrama eléctrico y no sabes por dónde empezar', 'Entiendes algunas cosas, pero dependes de otro técnico para confirmar', 'Has visto videos o cursos, pero todo se siente desordenado y sin lógica', 'Evitas trabajos con tableros o motores por miedo a equivocarte', 'Sientes que sabes "hacer cosas", pero no sabes explicar ni resolver', 'Estás cansado de teoría y necesitas algo que sí puedas aplicar en el trabajo'];
  return <section className="bg-cream py-8 px-4" data-id="element-311">
      <div className="max-w-[600px] mx-auto" data-id="element-312">
        <h2 className="text-[24px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-313">
          <AlertTriangleIcon className="w-6 h-6 text-amber-500" data-id="element-314" />
          ESTE RECURSO ES PARA TI SI…
        </h2>

        <div className="bg-brand-black-light border border-white/10 rounded-xl p-6 shadow-soft" data-id="element-315">
          <div className="space-y-5" data-id="element-316">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-317">
                <XCircleIcon className="w-6 h-6 text-danger flex-shrink-0 mt-0.5" data-id="element-318" />
                <p className="text-dark-gray text-[15px] leading-relaxed m-0" data-id="element-319">
                  {point}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}